"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEST_CONFERENCE_TYPE = exports.LESSON_CONFERENCE_TYPES = void 0;
exports.LESSON_CONFERENCE_TYPES = ['lesson', 'duplex', 'vod'];
exports.TEST_CONFERENCE_TYPE = ['mock_test'];
